"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _player = require("../../reducers/player.js");
var _withRecaptcha = _interopRequireDefault(require("../../helpers/withRecaptcha.js"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _FlowListPicker = _interopRequireDefault(require("../FlowListPicker"));
var _LanguagePicker = _interopRequireDefault(require("../LanguagePicker"));
var _Mediator = _interopRequireDefault(require("../Mediator"));
var _assignmentQuery = _interopRequireDefault(require("./assignmentQuery.graphql"));
var _flowInfoQuery = _interopRequireDefault(require("./flowInfoQuery.graphql"));
var _pawnFlowListQuery = _interopRequireDefault(require("./pawnFlowListQuery.graphql"));
var _pawnLanguageQuery = _interopRequireDefault(require("./pawnLanguageQuery.graphql"));
var _progressQuery = _interopRequireDefault(require("./progressQuery.graphql"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/no-unused-state */ // Components
// Queries
var Boilerplate = window.cccisd.boilerplate;
var Cccisd = window.cccisd;
var Fortress = window.cccisd.fortress;
var repeatedFlowsKeysToOmit = ['repeatQuery', 'repeatQueryFlowVars', 'repeatQueryRequiredVariables', 'repeatQueryResultValuePath'];
var dataVarKeysToOmit = ['dataQuery', 'dataQueryFlowVars', 'dataQueryRequiredVariables', 'dataQueryResultValuePath'];
var Assignment = /*#__PURE__*/function (_React$Component) {
  function Assignment() {
    var _this;
    _classCallCheck(this, Assignment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Assignment, [].concat(args));
    _defineProperty(_this, "state", {
      assignmentProgressId: null,
      chosenLanguage: null,
      chosenFlowList: null,
      randomizing: false,
      flowProgress: null,
      progressChecked: false,
      savedLanguage: null,
      savedFlowList: null,
      assignmentSavedLanguage: null,
      assignmentSavedFlowList: null,
      annotatedFlows: undefined,
      // allow children to know about network error before unmounting them
      isNetworkError: false,
      isNetworkErrorUnmountChildren: false
    });
    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "sendProgressRequest", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(send) {
        var response, _response, _response$data, status, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!_this.state.isNetworkError) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return send();
            case 2:
              response = _context.v;
              status = ((_response = response) === null || _response === void 0 ? void 0 : (_response$data = _response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) || 'success';
              if (!(response.status > 400 || status !== 'success')) {
                _context.n = 3;
                break;
              }
              throw new Error('Network error');
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              _this.setState({
                isNetworkError: true
              }, function () {
                setTimeout(function () {
                  return _this.setState({
                    isNetworkErrorUnmountChildren: true
                  });
                }, 500);
              });
            case 5:
              return _context.a(2, response);
          }
        }, _callee, null, [[1, 4]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "checkProgress", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this$props, flowList, flowLists, flowProgress, isPreviewMode, language, languages, surveylists, checkPromises, queryProgressPromise, queryLanguagePromise, flowListArray, queryFlowListPromise, queryAssignmentPromise;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this$props = _this.props, flowList = _this$props.flowList, flowLists = _this$props.flowLists, flowProgress = _this$props.flowProgress, isPreviewMode = _this$props.isPreviewMode, language = _this$props.language, languages = _this$props.languages, surveylists = _this$props.surveylists;
            if (isPreviewMode) {
              _context2.n = 1;
              break;
            }
            checkPromises = [];
            if (flowProgress === null) {
              queryProgressPromise = _this.queryProgress();
              checkPromises.push(queryProgressPromise);
            }
            if (language === null && languages.length > 1) {
              queryLanguagePromise = _this.queryLanguage();
              checkPromises.push(queryLanguagePromise);
            }
            flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
            if (flowList === null && flowListArray.length > 1) {
              queryFlowListPromise = _this.queryFlowList();
              checkPromises.push(queryFlowListPromise);
            }
            if (flowList === null && flowListArray.length > 1 || language === null && languages.length > 1) {
              queryAssignmentPromise = _this.queryAssignment();
              checkPromises.push(queryAssignmentPromise);
            }
            _context2.n = 1;
            return Promise.all(checkPromises);
          case 1:
            _context2.n = 2;
            return _this.launchRandomizer();
          case 2:
            _this.setState({
              progressChecked: true
            });
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "queryProgress", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var result;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return _cccisdApollo.client.query({
              query: _progressQuery["default"],
              fetchPolicy: 'network-only',
              variables: {
                pawnId: _this.getPawnId(),
                responseSet: [_this.getResponseSet()]
              }
            });
          case 1:
            result = _context3.v;
            _this.setState({
              flowProgress: result.data.roles.anyRole.flowProgressList
            });
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    })));
    _defineProperty(_this, "queryFlowList", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var result;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            if (_this.props.shouldSaveFlowList) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            _context4.n = 2;
            return _cccisdApollo.client.query({
              query: _pawnFlowListQuery["default"],
              fetchPolicy: 'network-only',
              variables: {
                pawnId: _this.getPawnId()
              }
            });
          case 2:
            result = _context4.v;
            _this.setState({
              savedFlowList: result.data.roles.anyRole.fields.flowList
            });
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    })));
    _defineProperty(_this, "queryLanguage", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var result;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            if (_this.props.shouldSaveLanguage) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            _context5.n = 2;
            return _cccisdApollo.client.query({
              query: _pawnLanguageQuery["default"],
              fetchPolicy: 'network-only',
              variables: {
                pawnId: _this.getPawnId()
              }
            });
          case 2:
            result = _context5.v;
            _this.setState({
              savedLanguage: result.data.roles.anyRole.fields.language
            });
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    })));
    _defineProperty(_this, "queryAssignment", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var _this$props2, handle, assignmentProgressChecked, result, assignment;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _this$props2 = _this.props, handle = _this$props2.handle, assignmentProgressChecked = _this$props2.assignmentProgressChecked; // we already checked assignmentProgress in DeploymentPlayer
            if (!assignmentProgressChecked) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            _context6.n = 2;
            return _cccisdApollo.client.query({
              query: _assignmentQuery["default"],
              fetchPolicy: 'network-only',
              variables: {
                assignmentHandle: handle,
                pawnId: _this.getPawnId(),
                responseSet: _this.getResponseSet()
              }
            });
          case 2:
            result = _context6.v;
            assignment = result.data.roles.anyRole.assignmentProgress;
            if (assignment.flowList) {
              _this.setState({
                assignmentSavedFlowList: assignment.flowList
              });
            }
            if (assignment.language) {
              _this.setState({
                assignmentSavedLanguage: assignment.language
              });
            }
          case 3:
            return _context6.a(2);
        }
      }, _callee6);
    })));
    _defineProperty(_this, "launchRandomizer", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var flowListInfo, _this$props3, isPreviewMode, flowLists, flowListRandomizer, surveylists, flowListArray;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            flowListInfo = _this.flowListInfo();
            _this$props3 = _this.props, isPreviewMode = _this$props3.isPreviewMode, flowLists = _this$props3.flowLists, flowListRandomizer = _this$props3.flowListRandomizer, surveylists = _this$props3.surveylists;
            if (!flowListInfo.randomizerNeeded) {
              _context7.n = 3;
              break;
            }
            _this.setState({
              randomizing: true
            });
            if (!isPreviewMode) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2);
          case 1:
            flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
            if (!(flowListRandomizer !== null)) {
              _context7.n = 2;
              break;
            }
            flowListRandomizer(flowListArray, _this.onFlowListPicked);
            _context7.n = 3;
            break;
          case 2:
            _context7.n = 3;
            return _this.flowListRandomizer(flowListArray, _this.onFlowListPicked);
          case 3:
            return _context7.a(2);
        }
      }, _callee7);
    })));
    _defineProperty(_this, "getResponseSet", function () {
      return _this.props.flowProps.responseSet || 1;
    });
    _defineProperty(_this, "getFlowProgress", function () {
      /* in cases where language is changed, this component refetches flowProgress for new language
       * so use progress from state instead of whatever was passed as prop */
      return _this.state.chosenLanguage ? _this.state.flowProgress || _this.props.flowProgress || [] : _this.props.flowProgress || _this.state.flowProgress || [];
    });
    _defineProperty(_this, "getPawnId", function () {
      return _this.props.flowProps.pawnId || Fortress.user.acting.id;
    });
    _defineProperty(_this, "getPawnHash", function () {
      return _this.props.flowProps.pawnHash || Fortress.user.acting.random_hash;
    });
    _defineProperty(_this, "languageInfo", function () {
      var _this$props4 = _this.props,
        languages = _this$props4.languages,
        handle = _this$props4.handle,
        allowLanguageChange = _this$props4.allowLanguageChange;
      var _this$state = _this.state,
        assignmentSavedLanguage = _this$state.assignmentSavedLanguage,
        savedLanguage = _this$state.savedLanguage;
      var language = _this.props.language || assignmentSavedLanguage || savedLanguage;
      if (language !== null) {
        if (languages !== null && languages.indexOf(language) === -1) {
          console.error("Specified language ".concat(language, " for assignment ").concat(handle, " not in language list ").concat(languages));
          language = languages.length === 1 ? languages[0] : undefined;
        }
        if (!allowLanguageChange || languages === null || languages.length < 2) {
          return {
            language: language,
            pickerNeeded: false
          };
        }
        if (_this.state.chosenLanguage !== null) {
          return {
            language: _this.state.chosenLanguage,
            pickerNeeded: false
          };
        }
        return {
          language: language,
          pickerNeeded: true
        };
      }
      if (languages === null || languages.length === 0) {
        return {
          language: null,
          pickerNeeded: false
        };
      }
      if (languages.length === 1) {
        return {
          language: languages[0],
          pickerNeeded: false
        };
      }
      if (_this.state.chosenLanguage === null) {
        return {
          language: null,
          pickerNeeded: true
        };
      }
      if (languages.indexOf(_this.state.chosenLanguage) === -1) {
        return {
          language: null,
          pickerNeeded: true
        };
      }
      return {
        language: _this.state.chosenLanguage,
        pickerNeeded: false
      };
    });
    _defineProperty(_this, "flowListInfo", function () {
      var _this$props5 = _this.props,
        flowLists = _this$props5.flowLists,
        handle = _this$props5.handle,
        surveylists = _this$props5.surveylists;
      var _this$state2 = _this.state,
        assignmentSavedFlowList = _this$state2.assignmentSavedFlowList,
        savedFlowList = _this$state2.savedFlowList;
      var flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
      var flowList = _this.props.flowList || assignmentSavedFlowList || savedFlowList;
      if (flowList !== null) {
        if (flowListArray !== null && flowListArray.indexOf(flowList) === -1) {
          console.error("Specified flowList ".concat(flowList, " of assignment ").concat(handle, " not in flowList list ").concat(flowListArray));
          flowList = null;
        } else {
          return {
            flowList: flowList,
            randomizerNeeded: false
          };
        }
      }
      if (flowListArray.length === 0) {
        console.error('No flowLists defined');
      }
      if (flowListArray.length === 1) {
        return {
          flowList: flowListArray[0],
          randomizerNeeded: false
        };
      }
      if (_this.state.chosenFlowList === null || flowListArray.indexOf(_this.state.chosenFlowList) === -1) {
        return {
          flowList: null,
          randomizerNeeded: true
        };
      }
      return {
        flowList: _this.state.chosenFlowList,
        randomizerNeeded: false
      };
    });
    _defineProperty(_this, "onLanguagePicked", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(language) {
        var prevLanguage, _this$props6, handle, languages;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!(_this.props.languages.indexOf(language) !== -1)) {
                _context8.n = 2;
                break;
              }
              prevLanguage = _this.languageInfo().language;
              if (!(language !== prevLanguage)) {
                _context8.n = 1;
                break;
              }
              _context8.n = 1;
              return _this.queryProgress();
            case 1:
              _this.saveLanguage(language);
              _this.setState({
                chosenLanguage: language
              });
              _context8.n = 3;
              break;
            case 2:
              _this$props6 = _this.props, handle = _this$props6.handle, languages = _this$props6.languages;
              console.error("Chosen language ".concat(language, " for assignment ").concat(handle, " not in language list ").concat(languages));
              _this.setState({
                chosenLanguage: languages[0]
              });
            case 3:
              return _context8.a(2);
          }
        }, _callee8);
      }));
      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "saveLanguage", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(language) {
        var _this$props7, isPreviewMode, shouldSaveLanguage;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              // TODO: save language for pawns other than acting
              _this$props7 = _this.props, isPreviewMode = _this$props7.isPreviewMode, shouldSaveLanguage = _this$props7.shouldSaveLanguage;
              if (!(isPreviewMode || !shouldSaveLanguage)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              _context9.n = 2;
              return _this.sendProgressRequest(function () {
                return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                  pawn: _this.getPawnId()
                }), {
                  pawnId: _this.getPawnId(),
                  pawnHash: _this.getPawnHash(),
                  language: language
                });
              });
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }));
      return function (_x3) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onFlowListPicked", /*#__PURE__*/function () {
      var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(flowList) {
        var _this$props8, flowLists, handle, surveylists, flowListArray;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _this$props8 = _this.props, flowLists = _this$props8.flowLists, handle = _this$props8.handle, surveylists = _this$props8.surveylists;
              flowListArray = surveylists ? Object.keys(surveylists) : Object.keys(flowLists);
              if (!(flowListArray.indexOf(flowList) !== -1)) {
                _context0.n = 2;
                break;
              }
              _context0.n = 1;
              return _this.saveFlowList(flowList);
            case 1:
              _this.setState({
                chosenFlowList: flowList,
                randomizing: false
              });
              _context0.n = 3;
              break;
            case 2:
              console.error("Chosen flowList ".concat(flowList, " for assignment ").concat(handle, " not in flowLists ").concat(flowListArray));
              _this.setState({
                chosenFlowList: flowListArray[0],
                randomizing: false
              });
            case 3:
              return _context0.a(2);
          }
        }, _callee0);
      }));
      return function (_x4) {
        return _ref0.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "saveFlowList", /*#__PURE__*/function () {
      var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(flowList) {
        var _this$props9, isPreviewMode, shouldSaveFlowList;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _this$props9 = _this.props, isPreviewMode = _this$props9.isPreviewMode, shouldSaveFlowList = _this$props9.shouldSaveFlowList;
              if (!(isPreviewMode || !shouldSaveFlowList)) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              _context1.n = 2;
              return _this.sendProgressRequest(function () {
                return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.update', {
                  pawn: _this.getPawnId()
                }), {
                  pawnId: _this.getPawnId(),
                  pawnHash: _this.getPawnHash(),
                  flowList: flowList
                });
              });
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }));
      return function (_x5) {
        return _ref1.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "flowListRandomizer", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(flowListArray, onFlowListPicked) {
        var flowList;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              // TODO: check flowListArray chosen in other response sets, do not
              // re-use if we haven't used them all
              flowList = flowListArray[Math.floor(Math.random() * flowListArray.length)];
              _context10.n = 1;
              return onFlowListPicked(flowList);
            case 1:
              return _context10.a(2);
          }
        }, _callee10);
      }));
      return function (_x6, _x7) {
        return _ref10.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getAnnotatedFlows", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
      var _this$props0, allSurveyProgress, flowLists, genericFlowProps, isPreviewMode, options, surveylists, requiredOptions, sortByAssignmentOptions, language, flowList, responseSet, flows, _annotatedFlows, formFlowObjects, suffix, shownOnly, includingRepeats, includingData, annotatedFlows, _iterator, _step, flow, handle, isComplete, isStarted, _iterator2, _step2, subProgress, keys, flowProgress, _iterator3, _step3, progress, flowProps, tempFlow, _t2, _t3, _t4;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            _this$props0 = _this.props, allSurveyProgress = _this$props0.allSurveyProgress, flowLists = _this$props0.flowLists, genericFlowProps = _this$props0.flowProps, isPreviewMode = _this$props0.isPreviewMode, options = _this$props0.options, surveylists = _this$props0.surveylists, requiredOptions = _this$props0.requiredOptions, sortByAssignmentOptions = _this$props0.sortByAssignmentOptions;
            language = _this.languageInfo().language;
            flowList = _this.flowListInfo().flowList;
            responseSet = _this.getResponseSet();
            /* If `allSurveyProgress` is passed as prop, then it has all the info we need.
             * This is not guaranteed if someone uses <Assignment/> directly instead of
             * via <DeploymentPlayer/>, so keep the other logic for backwards compatibility
             */
            if (!(allSurveyProgress && _typeof(allSurveyProgress) === 'object' && !Array.isArray(allSurveyProgress) && typeof language === 'string' && typeof flowList === 'string' && typeof responseSet === 'number')) {
              _context11.n = 4;
              break;
            }
            // Initial state from backend
            flows = (0, _get2["default"])(allSurveyProgress, "".concat(flowList, ".").concat(language), []); // get into proper structure
            _annotatedFlows = flows.filter(function (flow) {
              var showIfOption = (0, _get2["default"])(flow, 'survey_settings.showIfOption');
              // very old surveys might not have this key defined in settings
              if (!showIfOption) {
                return true;
              }
              return Array.isArray(showIfOption) ? showIfOption.some(function (opt) {
                return options.includes(opt);
              }) : options.includes(showIfOption);
            }).map(function (flow) {
              var showIfOption = (0, _get2["default"])(flow, 'survey_settings.showIfOption', [flow.survey_handle]);
              var isRequired = (0, _get2["default"])(flow, 'survey_settings.isRequired', false);
              if (Array.isArray(requiredOptions)) {
                isRequired = Array.isArray(showIfOption) ? showIfOption.some(function (opt) {
                  return requiredOptions.includes(opt);
                }) : requiredOptions.includes(showIfOption);
              }
              var flowSettings = typeof flow.flow_settings === 'string' ? JSON.parse(flow.flow_settings) : flow.flow_settings;
              var surveySettings = typeof flow.survey_settings === 'string' ? JSON.parse(flow.survey_settings) : flow.survey_settings;
              return _objectSpread(_objectSpread(_objectSpread({
                flowId: flow.flow_id,
                flowSettings: flowSettings,
                handle: flow.flow_handle,
                isComplete: !isPreviewMode && Boolean(flow.flow_finished),
                isPreviewMode: isPreviewMode,
                isStarted: !isPreviewMode && Boolean(flow.flow_started),
                language: language,
                lastVisited: !isPreviewMode && flow.flow_last_visited,
                ordinalPosition: flow.survey_order,
                pawnId: _this.getPawnId(),
                pawnHash: _this.getPawnHash(),
                responseSet: responseSet,
                showIfOption: showIfOption,
                surveySettings: (0, _omit2["default"])(surveySettings, [].concat(repeatedFlowsKeysToOmit, dataVarKeysToOmit))
              }, surveySettings), _typeof(flow.flowProps) === 'object' ? flow.flowProps : {}), {}, {
                // all things that can be overriden via props (`requiredOptions` or `flowProps`)
                isRequired: isRequired
              }, genericFlowProps);
            });
            if (sortByAssignmentOptions) {
              _annotatedFlows = (0, _sortBy2["default"])(_annotatedFlows, function (flow) {
                return options.indexOf(flow.handle);
              });
            }

            // Handle if flow has flow.repeatQuery
            _context11.n = 1;
            return _this.getRepeatedFlows(_annotatedFlows);
          case 1:
            _annotatedFlows = _context11.v;
            _context11.n = 2;
            return _this.getFlowVarData(_annotatedFlows);
          case 2:
            _annotatedFlows = _context11.v;
            _context11.n = 3;
            return _this.setProgressBar(_annotatedFlows);
          case 3:
            _this.setState({
              annotatedFlows: _annotatedFlows
            });
            return _context11.a(2);
          case 4:
            // All code below is for backwards compatibility only
            formFlowObjects = flowLists ? flowLists[flowList] : surveylists[flowList];
            suffix = language && !surveylists ? "-".concat(language) : '';
            if (formFlowObjects) {
              _context11.n = 5;
              break;
            }
            return _context11.a(2, undefined);
          case 5:
            shownOnly = formFlowObjects.filter(function (flow) {
              if (!flow.showIfOption) {
                return true;
              }
              var showIfOption = Array.isArray(flow.showIfOption) ? flow.showIfOption : [flow.showIfOption];
              return showIfOption.some(function (opt) {
                return options.includes(opt);
              });
            });
            _context11.n = 6;
            return _this.getRepeatedFlows(shownOnly);
          case 6:
            includingRepeats = _context11.v;
            _context11.n = 7;
            return _this.getFlowVarData(includingRepeats);
          case 7:
            includingData = _context11.v;
            annotatedFlows = [];
            _iterator = _createForOfIteratorHelper(includingData);
            _context11.p = 8;
            _iterator.s();
          case 9:
            if ((_step = _iterator.n()).done) {
              _context11.n = 27;
              break;
            }
            flow = _step.value;
            flow = typeof flow === 'string' ? {
              handle: flow
            } : flow;
            handle = "".concat(flow.handle).concat(suffix);
            isComplete = false;
            isStarted = false;
            if (!flow.subFlowProgress) {
              _context11.n = 18;
              break;
            }
            _iterator2 = _createForOfIteratorHelper(flow.subFlowProgress);
            _context11.p = 10;
            _iterator2.s();
          case 11:
            if ((_step2 = _iterator2.n()).done) {
              _context11.n = 14;
              break;
            }
            subProgress = _step2.value;
            if (!(subProgress.responseSet === responseSet)) {
              _context11.n = 13;
              break;
            }
            if (!(subProgress.flowLanguage && subProgress.flowLanguage !== language)) {
              _context11.n = 12;
              break;
            }
            return _context11.a(3, 13);
          case 12:
            keys = Object.keys(subProgress);
            if (keys.includes('completed')) {
              isComplete = subProgress.completed;
            }
            if (keys.includes('started')) {
              isStarted = subProgress.started;
            }
            return _context11.a(3, 14);
          case 13:
            _context11.n = 11;
            break;
          case 14:
            _context11.n = 16;
            break;
          case 15:
            _context11.p = 15;
            _t2 = _context11.v;
            _iterator2.e(_t2);
          case 16:
            _context11.p = 16;
            _iterator2.f();
            return _context11.f(16);
          case 17:
            _context11.n = 25;
            break;
          case 18:
            flowProgress = _this.getFlowProgress();
            _iterator3 = _createForOfIteratorHelper(flowProgress);
            _context11.p = 19;
            _iterator3.s();
          case 20:
            if ((_step3 = _iterator3.n()).done) {
              _context11.n = 22;
              break;
            }
            progress = _step3.value;
            if (!(progress.flowHandle === handle && progress.responseSet === responseSet && progress.flowLanguage === language)) {
              _context11.n = 21;
              break;
            }
            isComplete = progress.completed;
            isStarted = progress.started;
            return _context11.a(3, 22);
          case 21:
            _context11.n = 20;
            break;
          case 22:
            _context11.n = 24;
            break;
          case 23:
            _context11.p = 23;
            _t3 = _context11.v;
            _iterator3.e(_t3);
          case 24:
            _context11.p = 24;
            _iterator3.f();
            return _context11.f(24);
          case 25:
            flowProps = flow.flowProps || {};
            tempFlow = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, flow), genericFlowProps), flowProps), {}, {
              handle: handle,
              isComplete: isPreviewMode ? false : isComplete,
              isPreviewMode: isPreviewMode,
              isStarted: isPreviewMode ? false : isStarted,
              pawnId: flow.pawnId || _this.getPawnId(),
              pawnHash: flow.pawnHash || _this.getPawnHash(),
              responseSet: responseSet
            });
            if (Array.isArray(requiredOptions)) {
              tempFlow.isRequired = Array.isArray(tempFlow.showIfOption) ? tempFlow.showIfOption.some(function (opt) {
                return requiredOptions.includes(opt);
              }) : requiredOptions.includes(tempFlow.showIfOption);
            }
            if (tempFlow.isRequired === undefined) {
              tempFlow.isRequired = true;
            }
            if (language && surveylists) {
              tempFlow.language = language;
            }
            annotatedFlows.push(tempFlow);
          case 26:
            _context11.n = 9;
            break;
          case 27:
            _context11.n = 29;
            break;
          case 28:
            _context11.p = 28;
            _t4 = _context11.v;
            _iterator.e(_t4);
          case 29:
            _context11.p = 29;
            _iterator.f();
            return _context11.f(29);
          case 30:
            _context11.n = 31;
            return _this.addFlowInfo(annotatedFlows);
          case 31:
            _context11.n = 32;
            return _this.setProgressBar(annotatedFlows);
          case 32:
            annotatedFlows.sort(_this.sortByOrdinalPosition);
            _this.setState({
              annotatedFlows: annotatedFlows
            });
          case 33:
            return _context11.a(2);
        }
      }, _callee11, null, [[19, 23, 24, 25], [10, 15, 16, 17], [8, 28, 29, 30]]);
    })));
    _defineProperty(_this, "sortByOrdinalPosition", function (f1, f2) {
      if (f1.ordinalPosition < f2.ordinalPosition) {
        return -1;
      }
      if (f1.ordinalPosition > f2.ordinalPosition) {
        return 1;
      }
      return 0;
    });
    _defineProperty(_this, "getRepeatedFlows", /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(flows) {
        var flowsWithRepeats, _iterator4, _step4, flow, processedFlows, _t5;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              flowsWithRepeats = [];
              _iterator4 = _createForOfIteratorHelper(flows);
              _context12.p = 1;
              _iterator4.s();
            case 2:
              if ((_step4 = _iterator4.n()).done) {
                _context12.n = 5;
                break;
              }
              flow = _step4.value;
              _context12.n = 3;
              return _this.processRepeatedFlow(flow);
            case 3:
              processedFlows = _context12.v;
              flowsWithRepeats = flowsWithRepeats.concat(processedFlows);
            case 4:
              _context12.n = 2;
              break;
            case 5:
              _context12.n = 7;
              break;
            case 6:
              _context12.p = 6;
              _t5 = _context12.v;
              _iterator4.e(_t5);
            case 7:
              _context12.p = 7;
              _iterator4.f();
              return _context12.f(7);
            case 8:
              return _context12.a(2, flowsWithRepeats);
          }
        }, _callee12, null, [[1, 6, 7, 8]]);
      }));
      return function (_x8) {
        return _ref12.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "processRepeatedFlow", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(flow) {
        var variables, repeatQueryResult, resultList;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              if (flow.repeatQuery) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2, [flow]);
            case 1:
              variables = _this.buildRequiredVariables(flow.repeatQueryRequiredVariables, flow);
              _context13.n = 2;
              return _cccisdApollo.client.query({
                query: (0, _cccisdApollo.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                ", "\n            "])), flow.repeatQuery),
                fetchPolicy: 'network-only',
                variables: variables
              });
            case 2:
              repeatQueryResult = _context13.v;
              resultList = (0, _get2["default"])(repeatQueryResult.data, flow.repeatQueryResultValuePath, []);
              return _context13.a(2, _this.getBuiltRepeatedFlows(resultList, flow));
          }
        }, _callee13);
      }));
      return function (_x9) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getBuiltRepeatedFlows", function (resultList, flow) {
      var builtFlows = [];
      var varDefs = flow.repeatQueryFlowVars;
      if (!resultList.length || !varDefs) {
        return builtFlows;
      }
      var _iterator5 = _createForOfIteratorHelper(resultList),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var thisResult = _step5.value;
          var flowVars = {};
          var _iterator6 = _createForOfIteratorHelper(varDefs),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var varDef = _step6.value;
              var val = varDef.value ? (0, _get2["default"])(thisResult, varDef.value, undefined) : thisResult;
              var tempObj = _defineProperty({}, varDef.key, val);
              var objectData = _this.setObjectData(thisResult, varDef);
              Object.assign(flowVars, tempObj, objectData);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          builtFlows.push(Object.assign({}, (0, _omit2["default"])(flow, repeatedFlowsKeysToOmit), flowVars));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return builtFlows;
    });
    _defineProperty(_this, "getFlowVarData", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(flows) {
        var updatedFlows, _iterator7, _step7, flow, dataResult, updatedFlow, _t6;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              updatedFlows = [];
              _iterator7 = _createForOfIteratorHelper(flows);
              _context14.p = 1;
              _iterator7.s();
            case 2:
              if ((_step7 = _iterator7.n()).done) {
                _context14.n = 6;
                break;
              }
              flow = _step7.value;
              if (flow.dataQuery) {
                _context14.n = 3;
                break;
              }
              updatedFlows.push(flow);
              return _context14.a(3, 5);
            case 3:
              _context14.n = 4;
              return _this.runFlowVarDataQuery(flow);
            case 4:
              dataResult = _context14.v;
              updatedFlow = _this.addFlowVarsFromData(dataResult, flow);
              updatedFlows.push(updatedFlow);
            case 5:
              _context14.n = 2;
              break;
            case 6:
              _context14.n = 8;
              break;
            case 7:
              _context14.p = 7;
              _t6 = _context14.v;
              _iterator7.e(_t6);
            case 8:
              _context14.p = 8;
              _iterator7.f();
              return _context14.f(8);
            case 9:
              return _context14.a(2, updatedFlows);
          }
        }, _callee14, null, [[1, 7, 8, 9]]);
      }));
      return function (_x0) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "runFlowVarDataQuery", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(flow) {
        var variables, dataQueryResult;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              variables = _this.buildRequiredVariables(flow.dataQueryRequiredVariables, flow);
              _context15.n = 1;
              return _cccisdApollo.client.query({
                query: (0, _cccisdApollo.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                ", "\n            "])), flow.dataQuery),
                fetchPolicy: 'network-only',
                variables: variables
              });
            case 1:
              dataQueryResult = _context15.v;
              return _context15.a(2, (0, _get2["default"])(dataQueryResult.data, flow.dataQueryResultValuePath, {}));
          }
        }, _callee15);
      }));
      return function (_x1) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "addFlowVarsFromData", function (dataResult, flow) {
      var varDefs = flow.dataQueryFlowVars;
      var flowVars = {};
      if (!(0, _isEmpty2["default"])(dataResult) && varDefs.length) {
        var _iterator8 = _createForOfIteratorHelper(varDefs),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var varDef = _step8.value;
            var val = varDef.value ? (0, _get2["default"])(dataResult, varDef.value, undefined) : dataResult;
            val = varDef.userList ? _this.makeUserList(val, varDef) : val;
            var tempObj = varDef.userList ? _defineProperty({}, varDef.key, _defineProperty({}, varDef.userList, val)) : _defineProperty({}, varDef.key, val);
            var objectData = _this.setObjectData(dataResult, varDef);
            Object.assign(flowVars, tempObj, objectData);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
      return Object.assign({}, (0, _omit2["default"])(flow, dataVarKeysToOmit), flowVars);
    });
    _defineProperty(_this, "addFlowInfo", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(annotatedFlows) {
        var language, flowHandles, result, flowList, surveyList, _iterator9, _step9, _loop, _t7;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              language = _this.languageInfo().language;
              flowHandles = annotatedFlows.map(function (e) {
                return e.handle;
              });
              _context17.n = 1;
              return _cccisdApollo.client.query({
                query: _flowInfoQuery["default"],
                fetchPolicy: 'network-only',
                variables: {
                  language: language,
                  flowHandles: flowHandles
                }
              });
            case 1:
              result = _context17.v;
              flowList = (0, _get2["default"])(result, 'data.flows.flowList', []);
              surveyList = (0, _get2["default"])(result, 'data.flows.surveyList', []);
              _iterator9 = _createForOfIteratorHelper(annotatedFlows);
              _context17.p = 2;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var f, flowMatch, surveyMatch;
                return _regenerator().w(function (_context16) {
                  while (1) switch (_context16.n) {
                    case 0:
                      f = _step9.value;
                      flowMatch = flowList.find(function (e) {
                        return e.flowHandle === f.handle;
                      });
                      if (flowMatch) {
                        f.flowId = flowMatch.flowId;
                        f.flowSettings = flowMatch.settings;
                      }
                      surveyMatch = surveyList.find(function (e) {
                        return e.surveyHandle === f.handle;
                      });
                      if (surveyMatch) {
                        f.surveySettings = surveyMatch.settings;
                        f.ordinalPosition = surveyMatch.position;
                      }
                    case 1:
                      return _context16.a(2);
                  }
                }, _loop);
              });
              _iterator9.s();
            case 3:
              if ((_step9 = _iterator9.n()).done) {
                _context17.n = 5;
                break;
              }
              return _context17.d(_regeneratorValues(_loop()), 4);
            case 4:
              _context17.n = 3;
              break;
            case 5:
              _context17.n = 7;
              break;
            case 6:
              _context17.p = 6;
              _t7 = _context17.v;
              _iterator9.e(_t7);
            case 7:
              _context17.p = 7;
              _iterator9.f();
              return _context17.f(7);
            case 8:
              return _context17.a(2);
          }
        }, _callee16, null, [[2, 6, 7, 8]]);
      }));
      return function (_x10) {
        return _ref18.apply(this, arguments);
      };
    }());
    /**
     * If varDef has an objectDef, set the key/value pairs to an object of the
     * specified key from the supplied data.
     *
     * @param {Object|Array} data The data returned from a query
     * @param {Object} varDef The flow variables definition
     * @return {Object}
     */
    _defineProperty(_this, "setObjectData", function (data, varDef) {
      var dataObj = {};
      if (!varDef.objectDef || !varDef.key) {
        return dataObj;
      }
      var _iterator0 = _createForOfIteratorHelper(varDef.objectDef),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var objDef = _step0.value;
          var val = objDef.value ? (0, _get2["default"])(data, objDef.value, undefined) : data;
          var tempObj = _defineProperty({}, objDef.key, val);
          Object.assign(dataObj, tempObj);
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      return _defineProperty({}, varDef.key, dataObj);
    });
    _defineProperty(_this, "makeUserList", function (value, varDef) {
      if (!varDef.userList || !Array.isArray(value)) {
        return value;
      }
      var pawnIdPath = varDef.pawnIdPath || 'pawn.pawnId';
      var pawnHashPath = varDef.pawnHashPath || 'pawn.pawnHash';
      var namePath = varDef.namePath || 'user.fullName';
      var userList = [];
      var _iterator1 = _createForOfIteratorHelper(value),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var val = _step1.value;
          userList.push({
            pawnId: (0, _get2["default"])(val, pawnIdPath, undefined),
            pawnHash: (0, _get2["default"])(val, pawnHashPath, undefined),
            name: (0, _get2["default"])(val, namePath, undefined)
          });
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      return userList;
    });
    /**
     * Using the `variable` and `cccisdSource` properties of each required
     * variable object, return an object with the determined key: value pairs.
     *
     * @param {Object[]} reqVars An array of required variable objects
     * @param {Object} flow The flow definition
     * @return {Object}
     */
    _defineProperty(_this, "buildRequiredVariables", function (reqVars, flow) {
      var variables = {};
      flow.pawnId = flow.pawnId || _this.getPawnId();
      flow.pawnHash = flow.pawnHash || _this.getPawnHash();
      if (reqVars && Array.isArray(reqVars)) {
        var _iterator10 = _createForOfIteratorHelper(reqVars),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var rv = _step10.value;
            var value = void 0;
            if (rv.cccisdSource) {
              value = (0, _get2["default"])(Cccisd, rv.cccisdSource, undefined);
            } else if (rv.flowProp) {
              value = flow[rv.flowProp];
            }
            variables[rv.variable] = value;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      return variables;
    });
    _defineProperty(_this, "onFlowStarted", /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(flow) {
        var isPreviewMode, langInfo, flowListInfo, postInfo, response, commonData, promises;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              isPreviewMode = _this.props.isPreviewMode;
              if (!isPreviewMode) {
                _context18.n = 1;
                break;
              }
              return _context18.a(2);
            case 1:
              langInfo = _this.languageInfo();
              flowListInfo = _this.flowListInfo();
              postInfo = {
                deploymentId: _this.props.deploymentId,
                sessionId: _this.props.sessionId,
                assignment: _this.props.handle,
                flowlist: flowListInfo.flowList,
                language: langInfo.language,
                mostRecentFlow: flow.handle,
                pawnHash: _this.getPawnHash(),
                pawnId: _this.getPawnId(),
                responseSet: _this.getResponseSet()
              };
              _context18.n = 2;
              return _this.sendProgressRequest(function () {
                return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.update'), postInfo, {
                  timeout: 15 * 1000
                });
              });
            case 2:
              response = _context18.v;
              _this.setState({
                assignmentProgressId: response.assignmentProgressId
              });
              if (!flow.preFlowRoutes) {
                _context18.n = 3;
                break;
              }
              commonData = {
                deploymentId: _this.props.deploymentId,
                sessionId: _this.props.sessionId,
                assignment: _this.props.handle,
                flowlist: flowListInfo.flowList,
                language: langInfo.language,
                flow: flow.handle,
                pawnHash: _this.getPawnHash(),
                pawnId: _this.getPawnId(),
                responseSet: _this.getResponseSet()
              };
              promises = flow.preFlowRoutes.map(function (r) {
                var routeData = r.settings || {};
                routeData = Object.assign(routeData, commonData);
                return _this.sendProgressRequest(function () {
                  return _cccisdAxios["default"].post(Boilerplate.route(r.route), routeData, {
                    timeout: 15 * 1000
                  });
                });
              });
              _context18.n = 3;
              return Promise.all(promises);
            case 3:
              return _context18.a(2);
          }
        }, _callee17);
      }));
      return function (_x11) {
        return _ref20.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onFlowComplete", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(flow) {
        var completionInfo,
          langInfo,
          flowListInfo,
          commonData,
          promises,
          _args19 = arguments;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              completionInfo = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : {};
              if (!_this.props.isPreviewMode) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2);
            case 1:
              if (!flow.postFlowRoutes) {
                _context19.n = 2;
                break;
              }
              langInfo = _this.languageInfo();
              flowListInfo = _this.flowListInfo();
              commonData = {
                deploymentId: _this.props.deploymentId,
                sessionId: _this.props.sessionId,
                assignment: _this.props.handle,
                flowlist: flowListInfo.flowList,
                language: langInfo.language,
                flow: flow.handle,
                pawnHash: _this.getPawnHash(),
                pawnId: _this.getPawnId(),
                responseSet: _this.getResponseSet()
              };
              promises = flow.postFlowRoutes.map(function (r) {
                var routeData = r.settings || {};
                routeData = Object.assign(routeData, commonData);
                return _this.sendProgressRequest(function () {
                  return _cccisdAxios["default"].post(Boilerplate.route(r.route), routeData);
                });
              });
              _context19.n = 2;
              return Promise.all(promises);
            case 2:
              if (!_this.props.onFlowComplete) {
                _context19.n = 3;
                break;
              }
              _context19.n = 3;
              return _this.props.onFlowComplete(_objectSpread({
                flow: flow
              }, completionInfo));
            case 3:
              return _context19.a(2);
          }
        }, _callee18);
      }));
      return function (_x12) {
        return _ref21.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onAlreadyComplete", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
      var onAlreadyComplete, language, flowList, pawnId;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.n) {
          case 0:
            onAlreadyComplete = _this.props.onAlreadyComplete;
            if (!onAlreadyComplete) {
              _context20.n = 1;
              break;
            }
            language = _this.languageInfo().language;
            flowList = _this.flowListInfo().flowList;
            pawnId = _this.getPawnId();
            _context20.n = 1;
            return onAlreadyComplete(language, flowList, pawnId);
          case 1:
            return _context20.a(2);
        }
      }, _callee19);
    })));
    _defineProperty(_this, "onAssignmentComplete", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
      var isPreviewMode, langInfo, flowListInfo, postInfo;
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.n) {
          case 0:
            isPreviewMode = _this.props.isPreviewMode;
            if (!isPreviewMode) {
              _context21.n = 1;
              break;
            }
            return _context21.a(2);
          case 1:
            // Requirements complete
            langInfo = _this.languageInfo();
            flowListInfo = _this.flowListInfo();
            postInfo = {
              deploymentId: _this.props.deploymentId,
              sessionId: _this.props.sessionId,
              assignment: _this.props.handle,
              flowlist: flowListInfo.flowList,
              isComplete: true,
              language: langInfo.language,
              pawnHash: _this.getPawnHash(),
              pawnId: _this.getPawnId(),
              responseSet: _this.getResponseSet()
            };
            _context21.n = 2;
            return _this.sendProgressRequest(function () {
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.update'), postInfo);
            });
          case 2:
            return _context21.a(2);
        }
      }, _callee20);
    })));
    _defineProperty(_this, "onComplete", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
      var onComplete, language, flowList, pawnId;
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.n) {
          case 0:
            // All content complete
            onComplete = _this.props.onComplete;
            if (!(onComplete !== null)) {
              _context22.n = 1;
              break;
            }
            language = _this.languageInfo().language;
            flowList = _this.flowListInfo().flowList;
            pawnId = _this.getPawnId();
            _context22.n = 1;
            return _this.processOnComplete(onComplete, language, flowList, pawnId);
          case 1:
            return _context22.a(2);
        }
      }, _callee21);
    })));
    _defineProperty(_this, "onModuleComplete", /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(completionInfo) {
        var moduleId, isPreviewMode, langInfo, flowListInfo, postInfo;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              moduleId = completionInfo.moduleId;
              isPreviewMode = _this.props.isPreviewMode;
              if (!(isPreviewMode || moduleId === undefined)) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2);
            case 1:
              langInfo = _this.languageInfo();
              flowListInfo = _this.flowListInfo();
              postInfo = {
                deploymentId: _this.props.deploymentId,
                sessionId: _this.props.sessionId,
                assignment: _this.props.handle,
                flowlist: flowListInfo.flowList,
                isModuleComplete: true,
                moduleId: moduleId,
                language: langInfo.language,
                pawnHash: _this.getPawnHash(),
                pawnId: _this.getPawnId(),
                responseSet: _this.getResponseSet()
              };
              _context23.n = 2;
              return _this.sendProgressRequest(function () {
                return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.update'), postInfo);
              });
            case 2:
              if (!_this.props.onModuleComplete) {
                _context23.n = 3;
                break;
              }
              _context23.n = 3;
              return _this.props.onModuleComplete(completionInfo);
            case 3:
              return _context23.a(2);
          }
        }, _callee22);
      }));
      return function (_x13) {
        return _ref25.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "processOnComplete", /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(onComplete, language, flowList, pawnId) {
        var location, _t8;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              if (onComplete) {
                _context24.n = 1;
                break;
              }
              return _context24.a(2);
            case 1:
              if (!(typeof onComplete === 'function')) {
                _context24.n = 3;
                break;
              }
              _context24.n = 2;
              return onComplete(language, flowList, pawnId);
            case 2:
              return _context24.a(2);
            case 3:
              _t8 = onComplete.action;
              _context24.n = _t8 === 'redirect' ? 4 : 5;
              break;
            case 4:
              location = !onComplete.settings.isExternal ? Boilerplate.url(onComplete.settings.location) : onComplete.settings.location;
              window.location.replace(location);
              return _context24.a(3, 6);
            case 5:
              return _context24.a(3, 6);
            case 6:
              return _context24.a(2);
          }
        }, _callee23);
      }));
      return function (_x14, _x15, _x16, _x17) {
        return _ref26.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "setProgressBar", /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(annotatedFlows) {
        var initialProgressBar, _iterator11, _step11, flow, status, processedGroups, progressBar, _i, _initialProgressBar, pbObj, updatedPbObj, flowData, allComplete, noneStarted, _iterator12, _step12, innerPbObj, _t9;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.p = _context25.n) {
            case 0:
              initialProgressBar = [];
              _iterator11 = _createForOfIteratorHelper(annotatedFlows);
              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  flow = _step11.value;
                  status = flow.isComplete ? 'completed' : '';
                  if (!status) {
                    status = flow.isStarted ? 'started' : 'not_started';
                  }
                  if (flow.isPreview) {
                    status = 'not_started';
                  }
                  initialProgressBar.push({
                    flowData: _defineProperty({}, "".concat(flow.handle, "_").concat(flow.pawnId), status),
                    isCurrent: false,
                    isMilestone: flow.isMilestone || false,
                    groupName: flow.progressBarGroup,
                    status: status
                  });
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
              processedGroups = [];
              progressBar = [];
              _i = 0, _initialProgressBar = initialProgressBar;
            case 1:
              if (!(_i < _initialProgressBar.length)) {
                _context25.n = 13;
                break;
              }
              pbObj = _initialProgressBar[_i];
              updatedPbObj = Object.assign({}, pbObj);
              if (!pbObj.groupName) {
                _context25.n = 11;
                break;
              }
              if (!processedGroups.includes(pbObj.groupName)) {
                _context25.n = 2;
                break;
              }
              return _context25.a(3, 12);
            case 2:
              flowData = {};
              allComplete = true;
              noneStarted = true;
              _iterator12 = _createForOfIteratorHelper(initialProgressBar);
              _context25.p = 3;
              _iterator12.s();
            case 4:
              if ((_step12 = _iterator12.n()).done) {
                _context25.n = 7;
                break;
              }
              innerPbObj = _step12.value;
              if (!(pbObj.groupName !== innerPbObj.groupName)) {
                _context25.n = 5;
                break;
              }
              return _context25.a(3, 6);
            case 5:
              if (['completed', 'started'].includes(innerPbObj.status)) {
                noneStarted = false;
              }
              if (['not_started', 'started'].includes(innerPbObj.status)) {
                allComplete = false;
              }
              flowData = Object.assign(flowData, innerPbObj.flowData);
            case 6:
              _context25.n = 4;
              break;
            case 7:
              _context25.n = 9;
              break;
            case 8:
              _context25.p = 8;
              _t9 = _context25.v;
              _iterator12.e(_t9);
            case 9:
              _context25.p = 9;
              _iterator12.f();
              return _context25.f(9);
            case 10:
              updatedPbObj.flowData = flowData;
              updatedPbObj.status = allComplete ? 'completed' : '';
              if (!updatedPbObj.status) {
                updatedPbObj.status = noneStarted ? 'not_started' : 'started';
              }
              processedGroups.push(pbObj.groupName);
            case 11:
              delete updatedPbObj.groupName;
              progressBar.push(updatedPbObj);
            case 12:
              _i++;
              _context25.n = 1;
              break;
            case 13:
              _context25.n = 14;
              return _this.props.setProgressBar(progressBar);
            case 14:
              return _context25.a(2);
          }
        }, _callee24, null, [[3, 8, 9, 10]]);
      }));
      return function (_x18) {
        return _ref27.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(Assignment, _React$Component);
  return _createClass(Assignment, [{
    key: "componentDidMount",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // REACT LIFECYCLE METHODS ////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function componentDidMount() {
      this.checkProgress();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setProgressBar([]);
    }
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this$props1 = this.props,
        deploymentId = _this$props1.deploymentId,
        deploymentSettings = _this$props1.deploymentSettings,
        parentDeploymentId = _this$props1.parentDeploymentId,
        relatedDeploymentId = _this$props1.relatedDeploymentId,
        flowLists = _this$props1.flowLists,
        handle = _this$props1.handle,
        isFinalTestMode = _this$props1.isFinalTestMode,
        isPreviewMode = _this$props1.isPreviewMode,
        label = _this$props1.label,
        languagePicker = _this$props1.languagePicker,
        languages = _this$props1.languages,
        allowRetake = _this$props1.allowRetake,
        surveylists = _this$props1.surveylists,
        mediatorProps = _this$props1.mediatorProps,
        setIsShowingLayoutBgColor = _this$props1.setIsShowingLayoutBgColor,
        currentLayout = _this$props1.currentLayout;
      var _this$state3 = this.state,
        annotatedFlows = _this$state3.annotatedFlows,
        progressChecked = _this$state3.progressChecked,
        randomizing = _this$state3.randomizing,
        isNetworkError = _this$state3.isNetworkError,
        isNetworkErrorUnmountChildren = _this$state3.isNetworkErrorUnmountChildren;
      if (isNetworkError && isNetworkErrorUnmountChildren) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-warning"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "A network error has occurred. Please refresh your browser. You may have to resubmit any previously submitted responses. If the error persists, please contact technical support at", ' ', /*#__PURE__*/_react["default"].createElement("a", {
          href: "mailto:support@3cisd.com"
        }, "support@3cisd.com"), "."), /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-secondary",
          type: "button",
          onClick: function onClick() {
            return window.location.reload();
          },
          style: {
            marginTop: 15
          }
        }, "Try Again"));
      }
      if (randomizing && isPreviewMode) {
        return /*#__PURE__*/_react["default"].createElement(_FlowListPicker["default"], {
          flowListArray: surveylists ? Object.keys(surveylists) : Object.keys(flowLists),
          onFlowListPicked: this.onFlowListPicked
        });
      }
      if (randomizing || !progressChecked) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var languageInfo = this.languageInfo();
      if (languageInfo.pickerNeeded) {
        if (languagePicker !== null) {
          var picker = /*#__PURE__*/_react["default"].cloneElement(languagePicker, {
            onLanguagePicked: this.onLanguagePicked,
            initialLanguage: languageInfo.language,
            languages: languages
          });
          return {
            picker: picker
          };
        }
        return /*#__PURE__*/_react["default"].createElement(_LanguagePicker["default"], {
          onLanguagePicked: this.onLanguagePicked,
          initialLanguage: languageInfo.language,
          languages: languages
        });
      }
      if (annotatedFlows === undefined) {
        this.getAnnotatedFlows();
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      var MediatorComponent = this.props.mediator || _Mediator["default"];
      mediatorProps.setIsShowingLayoutBgColor = setIsShowingLayoutBgColor;
      mediatorProps.currentLayout = currentLayout;
      return /*#__PURE__*/_react["default"].createElement(MediatorComponent, {
        handle: handle,
        label: label,
        flowList: annotatedFlows,
        language: languageInfo.language,
        onFlowStarted: this.onFlowStarted,
        onFlowComplete: this.onFlowComplete,
        onComplete: this.onComplete,
        onAssignmentComplete: this.onAssignmentComplete,
        onModuleComplete: this.onModuleComplete,
        onAlreadyComplete: this.onAlreadyComplete,
        allowRetake: allowRetake,
        mediatorProps: mediatorProps,
        isFinalTestMode: isFinalTestMode,
        isPreviewMode: isPreviewMode,
        actingPawnHash: this.getPawnHash(),
        actingPawnId: this.getPawnId(),
        isNetworkError: isNetworkError,
        parentDeploymentId: parentDeploymentId,
        relatedDeploymentId: relatedDeploymentId,
        deploymentSettings: deploymentSettings,
        deploymentId: deploymentId
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(Assignment, "propTypes", {
  /** All existing progress for every surveylist/language combination */
  allSurveyProgress: _propTypes["default"].object,
  /** The deployment ID */
  deploymentId: _propTypes["default"].number,
  /** The assignment plan session ID */
  sessionId: _propTypes["default"].number,
  /** The Deployment settings - to be passed down to the mediator */
  deploymentSettings: _propTypes["default"].object,
  /** The parentDeployment ID, passed through to mediator */
  parentDeploymentId: _propTypes["default"].number,
  /** The relatedDeployment ID, passed through to mediator */
  relatedDeploymentId: _propTypes["default"].number,
  /** The assignment's handle in assignments.json */
  handle: _propTypes["default"].string.isRequired,
  /** The assignment's label in assignments.json; required by some navigations */
  label: _propTypes["default"].string,
  /** The flowLists this assignment has */
  flowLists: _propTypes["default"].object,
  /** The surveylists this assignment has */
  surveylists: _propTypes["default"].object,
  /** The flowList you want to use */
  flowList: _propTypes["default"].string,
  /** An alternate function to replace default flowListRandomizer */
  flowListRandomizer: _propTypes["default"].func,
  /** Should we save the selected flowList to `$pawn->data->flowList`? (default false) */
  shouldSaveFlowList: _propTypes["default"].bool,
  /** An alternate React Component to replace default Mediator */
  mediator: _propTypes["default"].func,
  /** Extra props for mediator */
  mediatorProps: _propTypes["default"].object,
  /** The language you want to use */
  language: _propTypes["default"].string,
  /** The languages this assignment supports */
  languages: _propTypes["default"].array,
  /** An alternate function to replace default LanguagePicker */
  languagePicker: _propTypes["default"].object,
  /** Should we allow changing of language? (default true) */
  allowLanguageChange: _propTypes["default"].bool,
  /** Should we save the selected language to `$pawn->data->language`? (default false) */
  shouldSaveLanguage: _propTypes["default"].bool,
  /** A function to call once assignment is complete (including non-required flows) */
  onComplete: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /** A function to call when required flows of a module are completed (modules navigation) */
  onModuleComplete: _propTypes["default"].func,
  /** A function to call each time a flow is completed */
  onFlowComplete: _propTypes["default"].func,
  /** A function to call if already complete (including non-required flows) and no retakes allowed */
  onAlreadyComplete: _propTypes["default"].func,
  /** An array of flow progress, i.e., from GraphQL. If provided, is used instead of querying for it. */
  flowProgress: _propTypes["default"].array,
  /** An array of strings for checking against `showIfOption` in flow object entries. If ANY match, flow will be included. */
  options: _propTypes["default"].array,
  /** Respect order of survey handles passed in through assignmentOptions */
  sortByAssignmentOptions: _propTypes["default"].bool,
  /** An array of strings for checking against `showIfOption` in flow object entries.
   * If ANY match, flow `isRequired` setting will be overridden to true.
   * For flows that are not included, `isRequired` will be overridden to false. */
  requiredOptions: _propTypes["default"].array,
  /** Allow a completed assignment to be retaken after completion? */
  allowRetake: _propTypes["default"].bool,
  /** Should we invoke the player in Final Test mode? */
  isFinalTestMode: _propTypes["default"].bool,
  /** Should we skip saving everything and not run any pre/postFlowRoutes? */
  isPreviewMode: _propTypes["default"].bool,
  /** If this an anonymous deployment, should we require a complete captcha before beginning survey? */
  showRecaptcha: _propTypes["default"].bool,
  /** An object containing props that each flow should have */flowProps: function flowProps(props, propName, componentName) {
    var flowProps = props[propName];
    if (_typeof(flowProps) !== 'object') {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Expecting type object but found ").concat(_typeof(flowProps), "."));
    }
    if (flowProps.pawnId && !flowProps.pawnHash && Number(Fortress.user.acting.id) !== Number(flowProps.pawnId)) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". 'pawnHash' must be provided when provided 'pawnId' does not match that of the acting user."));
    }
    if (!flowProps.pawnId && flowProps.pawnHash && Fortress.user.acting.random_hash !== flowProps.pawnHash) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". 'pawnId' must be provided when provided 'pawnHash' does not match that of the acting user."));
    }
  },
  // From redux
  setProgressBar: _propTypes["default"].func,
  // From PlayerLayout, used to toggle bg color in Course Wrapper
  setIsShowingLayoutBgColor: _propTypes["default"].func,
  // From PlayerLayout, provides current layout settings
  currentLayout: _propTypes["default"].object,
  /** It's true if assignment progress is already checked */
  assignmentProgressChecked: _propTypes["default"].bool
});
_defineProperty(Assignment, "defaultProps", {
  allSurveyProgress: null,
  deploymentId: null,
  sessionId: null,
  deploymentSettings: {},
  parentDeploymentId: null,
  relatedDeploymentId: null,
  mediator: null,
  language: null,
  languages: [],
  languagePicker: null,
  shouldSaveLanguage: false,
  allowLanguageChange: true,
  flowList: null,
  flowListRandomizer: null,
  shouldSaveFlowList: false,
  onComplete: null,
  onModuleComplete: null,
  onFlowComplete: null,
  onAlreadyComplete: null,
  flowProgress: null,
  options: [],
  sortByAssignmentOptions: false,
  requiredOptions: null,
  allowRetake: false,
  flowProps: {},
  isFinalTestMode: false,
  isPreviewMode: false,
  showRecaptcha: false
});
var ConnectedAssignment = (0, _reactRedux.connect)(null, {
  setProgressBar: _player.setProgressBar
})(Assignment);
var _default = exports["default"] = (0, _withRecaptcha["default"])(function (props) {
  return props.showRecaptcha;
})(ConnectedAssignment);